import { FormatListBulleted, FormatListNumbered } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { Editor } from "@tiptap/react";

import { useEffect, useState } from "react";

interface NoteListsProps {
    editor: Editor;
    mode: number;
}

export default function NoteLists({ editor, mode }: NoteListsProps) {
    const [isBulletListActive, setIsBulletListActive] = useState(false);
    const [isOrderedListActive, setIsOrderedListActive] = useState(false);

    useEffect(() => {
        const updateActiveStates = () => {
            setIsBulletListActive(editor.isActive('bulletList'));
            setIsOrderedListActive(editor.isActive('orderedList'));
        };

        editor.on('selectionUpdate', updateActiveStates);

        return () => {
            editor.off('selectionUpdate', updateActiveStates);
        };
    }, [editor]);

    const toggleBulletList = () => {
        editor.chain().focus().toggleBulletList().run();
        setIsBulletListActive(!isBulletListActive);
    };

    const toggleOrderedList = () => {
        editor.chain().focus().toggleOrderedList().run();
        setIsOrderedListActive(!isOrderedListActive);
    };


    return (
        <>
            <Tooltip title="Bulleted list">
                <IconButton
                    size="small"
                    onClick={toggleBulletList}
                    sx={{
                        backgroundColor: isBulletListActive ? '#e8f0fe' : 'transparent',
                        color: isBulletListActive ? (mode === 1 ? '#1a73e8' : "white") : (mode === 1 ? 'inherit' : 'white')
                    }}
                >
                    <FormatListBulleted sx={{ fontSize: 18 }} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Numbered list">
                <IconButton
                    size="small"
                    onClick={toggleOrderedList}
                    sx={{
                        backgroundColor: isOrderedListActive ? '#e8f0fe' : 'transparent',
                        color: isOrderedListActive ? (mode === 1 ? '#1a73e8' : "white") : (mode === 1 ? 'inherit' : 'white')
                    }}
                >
                    <FormatListNumbered sx={{ fontSize: 18 }} />
                </IconButton>
            </Tooltip>
        </>
    );
}
